import { Icon } from '@iconify/react';
import { fmt, fmtSigned } from '../utils/helpers';

const SummaryCards = ({ openingBalance, totalDebit, totalCredit, closingBalance }) => {
    const cards = [
        { label: 'Opening Balance', value: fmtSigned(openingBalance), icon: 'mdi:bank-outline',             color: 'tw-text-amber-700', bg: 'tw-bg-amber-50' },
        { label: 'Total Debit',     value: fmt(totalDebit),           icon: 'mdi:arrow-up-circle-outline',  color: 'tw-text-red-600',   bg: 'tw-bg-red-50' },
        { label: 'Total Credit',    value: fmt(totalCredit),          icon: 'mdi:arrow-down-circle-outline', color: 'tw-text-green-600', bg: 'tw-bg-green-50' },
        { label: 'Closing Balance', value: fmtSigned(closingBalance), icon: 'mdi:wallet-outline',           color: 'tw-text-blue-700',  bg: 'tw-bg-blue-50' },
    ];
    return (
        <div className="tw-grid tw-grid-cols-2 md:tw-grid-cols-4 tw-gap-3 tw-mb-4">
            {cards.map(c => (
                <div key={c.label} className="tw-bg-white tw-rounded-xl tw-border tw-border-gray-100 tw-shadow-sm tw-px-4 tw-py-3 tw-flex tw-items-center tw-gap-3">
                    <div className={`tw-w-9 tw-h-9 tw-rounded-lg ${c.bg} tw-flex tw-items-center tw-justify-center tw-flex-shrink-0`}>
                        <Icon icon={c.icon} className={`tw-text-lg ${c.color}`} />
                    </div>
                    <div>
                        <p className="tw-text-[10px] tw-text-gray-400 tw-font-medium tw-uppercase tw-tracking-wide">{c.label}</p>
                        <p className={`tw-text-sm tw-font-bold ${c.color}`}>{c.value}</p>
                    </div>
                </div>
            ))}
        </div>
    );
};

export default SummaryCards;
